import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PaymentsHostContainer from './payments-host-container';
import PaymentsGuestContainer from './payments-guest-container';
import Payments from '../../../api/api-payments';
import { Profile } from '../../../api/api-profile';
import { ManagedAccount } from './managed-account';
import { injectIntl, intlShape, defineMessages } from 'react-intl';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';
import { fetchAllFeeProfiles } from '../app-main/actions/fee-profile';
import { fetchRegionalFees } from '../app-main/actions/fees';
import { fetchInvoicesYears } from '../app-main/actions/invoices';
import { filter, get, reverse, sortBy, split } from 'lodash';
import AddressFormatter from '@shopify/address';
import { parseTaxDetailsScope } from './TaxDetails/TaxDetails.utils';
import TaxRegisteredModal from './modals/TaxRegisteredModal';
import { getUserExperiences } from '../../../assets/js/nux';
import { updateExperience } from '../app-main/actions/nux';

class PaymentsMain extends Component {
  constructor (props) {
    super(props);

    this.state = {
      account: {},
      cards: [],
      acctFetched: false,
      cardsFetched: false,
      creditsFetched: false,
      credits: {},
      isCanada: false,
      feeProfile: {},
      userCountry: '',
      showTaxRegisteredModal: false,
      nuxExperienceId: '',
      formattedBillingAddress: null,
      countryData: null
    };

    this.closeModal = this.closeModal.bind(this);
    this.updateNux = this.updateNux.bind(this);
    this.updateAccount = this.updateAccount.bind(this);
    this.formatBillingAddress = this.formatBillingAddress.bind(this);
  }

  componentDidMount () {
    const { profile, env, fee_profiles, dispatch, accessToken, fees, space, SSOid } = this.props;
    const { subFlow } = this.props.params;
    const isVatEnabled = _.get(env, 'web.is_vat_enabled', false);
    const hostSpaceCountry = _.get(space, 'countryStatus.data.country', '');

    dispatch(fetchAllFeeProfiles(accessToken, SSOid)).then((profiles) => {
      if (isVatEnabled) {
        const feeProfiles = _.get(this.props, 'fee_profiles', {});
        const vatAddresses = _.get(feeProfiles, 'vatAddress', []);
        const locale = SharedIntlProviderHOC.getLocale();

        let vatProfile = {}

        // only need sub region VAT profile since country will be the same as the
        // federal level VAT profile. Only difference is "state"
        if (vatAddresses.length > 1) {
          vatProfile = head(filter(vatAddresses, ['is_subregion', true]));
        } else {
          vatProfile = _.get(vatAddresses, '[0]', {});
        }

        const billingAddress = _.get(feeProfiles, 'billingAddress.data[0]');
        if (billingAddress) {
          this.formatBillingAddress(billingAddress);
        }
        const feeProfile = !_.isEmpty(vatProfile) ? vatProfile : billingAddress;
        const userCountry = _.get(feeProfile, 'country') || hostSpaceCountry || locale.split('-')[1];
        const isCanada = 'CA' === userCountry

        this.setState({
          isCanada,
          feeProfile,
          userCountry
        });

        const getRegionalFeesPayload = {
          country: userCountry,
          ...(isCanada && { state: _.get(feeProfile, 'state') })
        };

        dispatch(fetchRegionalFees(accessToken, getRegionalFeesPayload)).then(data => {
          //NUX call
          const ssoId = _.get(profile, 'SSOid', '');
          const isVatEnabled = _.get(env, 'web.is_vat_enabled');
          const regionalFees = _.get(data, 'fees', []);
          const isVatCountry = !_.isEmpty(_.filter(regionalFees, {category: 'VAT'}));

          if (isVatEnabled && isVatCountry && ('connected' === subFlow)) {
            // Only show NUX to hosts in country with VAT
            // returns ACTIVE but not yet completed experiences by user based on the query string
            getUserExperiences('name=vat-registered-modal', accessToken, (res) => {
              const experienceId = _.get(res, 'data[0]._id', null);
              const completedVatRegisteredExp = !experienceId;

              if (!completedVatRegisteredExp) {
                this.setState({
                  showTaxRegisteredModal: true,
                  nuxExperienceId: experienceId
                });
              }
            });
          }
        })

      }
    });

    dispatch(fetchInvoicesYears(SSOid, accessToken));
  }

  componentWillMount () {
    const { props } = this;
    const { profile, accessToken } = props;
    const { data } = profile;
    const acctId = data.account_id;
    const customerId = data.customer_id;
    const ssoId = profile.data.SSOid;

    if (acctId) {
     Payments.getManagedAccountData(ssoId, accessToken, (response) => {
        if (response.error) {
          return this.setState({ acctFetched: true });
        }
        this.setState({
          account: response,
          acctFetched: true
        });
      });
    }
    if (customerId) {
      Payments.getCustomerData(ssoId, accessToken, (response) => {
        this.setState({
          cards: _.get(response, 'data') || [],
          cardsFetched: true
        });
      });
    }

    Profile.readCredits(ssoId, accessToken, (response) => {
      this.setState({
        creditsFetched: true,
        credits: 200 === response.statusCode ? response : {}
      });
    });
  }

  updateAccount (account) {
    this.setState({
      account
    });
  }

  updateNux () {
    this.props.dispatch(updateExperience(this.state.nuxExperienceId));
  }

  closeModal (whichModal) {
    if ('taxRegisteredModal' === whichModal) {
      this.updateNux();
      this.setState({
        showTaxRegisteredModal: false
      });
    }
  }

  routeToTaxesTab () {
    this.updateNux();
    window.location.href = '/account/taxes';
  }

  formatBillingAddress (address) {
    const {
      street = '',
      unit = '',
      city = '',
      state = '',
      country = '',
      zip = ''
    } = address;
    const locale = split(SharedIntlProviderHOC.getLocale(), '-', 1)[0];
    const addressFormatter = new AddressFormatter(locale);

    addressFormatter.getCountry(country)
      .then((countryData => this.setState({ countryData: countryData })));

    addressFormatter.format({
      address1: street,
      address2: unit,
      city: city,
      province: state,
      zip: zip,
      country: country
    })
      .then(data => this.setState({ formattedBillingAddress: data }));
  }

  render () {
    const { profile, accessToken, env, intl, space, fee_profiles, fees,
    dispatch, invoices, isCanadaProfile } = this.props;
    const ssoId = _.get(profile, 'SSOid', '');
    const acctId = _.get(profile, 'data.account_id');
    const customerId = _.get(profile, 'data.customer_id');
    const isHost = _.get(profile, 'data.is_host');
    const isVatEnabled = _.get(env, 'web.is_vat_enabled', false);
    const feeTypes = _.get(fees, 'feeTypes', []);
    const federalFee = _.filter(feeTypes, (feeType) => { return !feeType.is_subregion; });
    const intlDataKey = isCanadaProfile ?
    'gst_hst' : _.get(federalFee, '[0].name', '');

    const {
      account,
      cards,
      acctFetched,
      cardsFetched,
      credits,
      creditsFetched,
      isCanada,
      feeProfile,
      userCountry,
      formattedBillingAddress,
      countryData
    } = this.state;

    const waitingForAccount = acctId && !acctFetched;
    const waitingForCards = customerId && !cardsFetched;
    const waitingForCredits = !creditsFetched;
    const { flow, subFlow, isEdit } = this.props.params;

    if (waitingForCards || waitingForAccount || waitingForCredits) {
      return <div />;
    }

    // changing def of hasAcct since now backend will auto-gen an account id
    const translationMessages = defineMessages({
      text: {
        id: 'hosting.payments_main.add_bank_account_info_text',
        defaultMessage: 'You cannot receive payouts until you add a bank account.'
      },
      acct: {
        id: 'hosting.payments_main.account_ending_text',
        defaultMessage: 'Account ending in {last4}'
      }
    });
    const hasAcct = _.get(account, 'business_type');
    const externalAccount = _.get(account, 'external_accounts.data[0]') || {};
    const externalAccountError = _.get(profile, 'data.external_accounts_error');
    const hasBank = !_.isEmpty(externalAccount);
    const hasPersons = !_.isEmpty(_.get(account, 'persons'));
    const verificationStatus = _.get(account, 'persons.0.verification.status');
    const isVerified = 'verified' === verificationStatus;
    const pendingFields = _.get(account, 'combined_requirements') || [];
    const isPending = hasAcct && ('pending' === verificationStatus);
    const pendingVerification = 'pending' === verificationStatus;
    const accountProblems = -1 !== ['verification_failed', 'errored'].indexOf(externalAccount.status);

    const text = intl.formatMessage(translationMessages.text);
    const bankName = externalAccount.bank_name;
    const last4 = externalAccount.last4;
    const acctString = intl.formatMessage(translationMessages.acct, { last4: last4 });

    const locale = SharedIntlProviderHOC.getLocale();

    const props = {
      hasAcct,
      externalAccount,
      externalAccountError,
      hasBank,
      hasPersons,
      isVerified,
      pendingVerification,
      stripeVerificationStatus: verificationStatus,
      pendingFields,
      isPending,
      accountProblems,
      text,
      bankName,
      last4,
      acctString,
      token: accessToken,
      profile: profile.data,
      flow,
      cards,
      account,
      credits,
      env,
      space,
      subFlow,
      // Which registration the tax details form is for. `null` for a `?scope=` we
      // do not serve, which the form renders as the error block.
      taxDetailsScope: parseTaxDetailsScope(get(this.props, 'location.query')),
      fee_profiles,
      fees,
      feeProfile,
      isVatEnabled,
      isEdit,
      isCanadaProfile: isCanada,
      dispatch,
      userCountry,
      invoices,
      formattedBillingAddress,
      countryData,
      locale,
      intl
    };

    let flowOptions = ['methods', 'payouts'];
    let guestFlowOptions = ['methods'];
    if (isVatEnabled) {
      flowOptions.push('taxes');
      guestFlowOptions.push('taxes');
    }

    if (isHost && (!flow || flowOptions.includes(flow))) {
      return (
        <div className="page account-page">
          <PaymentsHostContainer
            {...props}
            location={this.props.location}
            updateAccount={this.updateAccount}
          />
        </div>
      );
    }
    if (!flow || guestFlowOptions.includes(flow)) {
      return (
        <div className="page account-page">
          <PaymentsGuestContainer
            {...props}
            location={this.props.location}
            updateAccount={this.updateAccount}
          />
        </div>
      );
    }

    return (
      <div className="page account-page">
        <ManagedAccount
          {...props}
          updateAccount={this.updateAccount}
          isVatEnabled={isVatEnabled}
        />

        <TaxRegisteredModal
          showModal={this.state.showTaxRegisteredModal}
          showBtnSpinner={false}
          routeToTaxesTab={this.routeToTaxesTab}
          closeModal={this.closeModal}
          intlDataKey={intlDataKey}
          error={''}
          isHost={isHost}
        />
      </div>
    );
  };
}

export default connect(mapStateToProps)(injectIntl(PaymentsMain));

PaymentsMain.propTypes = {
  profile: PropTypes.object,
  accessToken: PropTypes.string,
  params: PropTypes.object,
  location: PropTypes.object,
  intl: intlShape,
  dispatch: PropTypes.func,
  env: PropTypes.object,
  space: PropTypes.object
};

function mapStateToProps (state) {
  const { fee_profiles, fees, invoices, space } = state;

  return {
    fee_profiles,
    fees,
    invoices,
    space
  };
}
